<template>
	<AppLayout :title="trans('menu.association.college-zone-representatives')">
		<template #actions>
			<Link v-if="canCreate" :as="PrimaryButton" :color="Color.Green" :href="route('association.college-zone-representatives.create')">
				<i class="fa-solid fa-plus mr-2"/>
				{{ trans('general.create') }}
			</Link>
		</template>
		<Empty v-if="representatives.length === 0"/>
		<CardGrid v-else>
			<Card v-for="representative in representatives" :key="`period-representative-${representative.id}`" :title="representative.assembly.title">
				<template #badges>
					<Badge :color="representative.color" active>{{ trans(`college_zones.representatives.status.${representative.status}`) }}</Badge>
				</template>
				<LabeledObject>
					<template #label>{{ trans('general.created_at') }}</template>
					<p>{{ dayjs(representative.created_at).format(trans('general.dayjs.datetime')) }}</p>
				</LabeledObject>
				<LabeledObject>
					<template #label>{{ trans('college_zones.representatives.college_zone') }}</template>
					<p>{{ trans(`colleges.${representative.college_zone}`) }}</p>
				</LabeledObject>
				<LabeledObject>
					<template #label>{{ trans('college_zones.representatives.college') }}</template>
					<p>{{ representative.college.name }}</p>
				</LabeledObject>
			</Card>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/Empty.vue'
import Card from '@/Components/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Badge from '@/Components/Badges/Badge.vue'
import CardGrid from '@/Components/Cards/CardGrid.vue'
import LabeledObject from '@/Components/LabeledObject.vue'
import PrimaryButton from '@/Components/Buttons/PrimaryButton.vue'
import {type CollegeZoneRepresentative} from '@/Types/Periods/CollegeZones/CollegeZoneRepresentative'

const props = defineProps<{
	canCreate:boolean,
	representatives:Array<CollegeZoneRepresentative>,
}>()

const representatives:Ref<Array<CollegeZoneRepresentative>> = ref(props.representatives)
</script>